var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"nofillpath"},[_c('circle',{attrs:{"cx":"12","cy":"9","r":"3","stroke":"#3C4043","stroke-width":"2"}}),_c('path',{attrs:{"d":"M20 10C20 15.5 13 22 12 22C11 22 4 15.5 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10Z","stroke":"#3C4043","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }